import { Markdown, MarkdownProps } from '@chronosphereio/chrono-ui';
import { MarkdownPanelPropsBase } from '@/core';
import {
  BasePanelProps,
  LinkDecorator,
  LinkDecoratorClassName,
  useReplaceVariablesInString,
} from '../../../plugin-system';

/**
 * Types for the markdown panel that are only used in the `Viz` variant.
 *
 * @see {@link MarkdownPanelPropsBase} for types defined in the schema because they are also shared with
 * the `DashboardPanel` variant.
 */
interface MarkdownPanelPropsVizOnly {
  // Currently no Viz only props, but leaving this here, so it is clear where to put them in the future.
}

export interface MarkdownPanelProps extends BasePanelProps, MarkdownPanelPropsBase, MarkdownPanelPropsVizOnly {
  // Extend values from `MarkdownPanelPropsBase` below, as needed, to add in jsdoc to help developers.
}

// Without this as 'constant' there's issues with the return type of the createMarkdownPanelStyles function
// not being valid CSS due to it's type being [x:string] instead of known properties
const LinkDecoratorClassSelector = `& .${LinkDecoratorClassName}` as 'LinkSelector';

const MARKDOWN_PROPS: MarkdownProps['ReactMarkdownProps'] = {
  components: {
    a: LinkDecorator,
  },
};

export function MarkdownPanel(props: MarkdownPanelProps) {
  const { text, width, height } = props;

  const contentDimensions = width && height ? { width, height } : undefined;

  const textAfterVariableReplacement = useReplaceVariablesInString(text);

  if (contentDimensions === undefined) return null;

  return (
    <Markdown
      sx={{
        width,
        height,

        // Add some margin for our decorated links so they don't bump up against each other on multiple lines
        [LinkDecoratorClassSelector]: {
          margin: '2px',
        },
      }}
      ReactMarkdownProps={MARKDOWN_PROPS}
    >
      {textAfterVariableReplacement || ''}
    </Markdown>
  );
}
